// extracted by mini-css-extract-plugin
export default {"signForms":"virtualSignForms_signForms__pWaEv","loading":"virtualSignForms_loading__o23zm","button":"virtualSignForms_button__oCSly"};